export enum CloudMimeTypesEnum {
  'ApplicationRtf' = 'application/rtf',
  'TextRtf' = 'text/rtf',
  'ApplicationMsWord' = 'application/msword',
  'ApplicationMSWordOpenXML' = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'ApplicationMsExcelOpenXML' = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'ApplicationMsPptOpenXML' = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'ApplicationPdf' = 'application/pdf',
  'TextHtml' = 'text/html',
  'KesNoType' = '',
  'ApplicationOctetStream' = 'application/octet-stream',
  'DriveFolder' = 'application/vnd.google-apps.folder',
  'SharedDrive' = 'sharedDrive',
  'Folder' = 'folder',
  'ImageJpeg' = 'image/jpeg',
  'ImageBmp' = 'image/bmp',
  'ImagePng' = 'image/png',
  'Mp3' = 'audio/mpeg',
  'GoogleDriveShortcut' = 'application/vnd.google-apps.shortcut',
  'ApplicationEpub' = 'application/epub+zip',
  'ApplicationBook' = 'application/alinea+zip',
}
